import { handleActions } from "redux-actions";

import {
	getPointsAdditionalListAsyncAction,
	postPointsAdditionalAsyncAction,
	updatePointsAdditionalAsyncAction,
	getPointsAdditionalAsyncAction,
	deletePointsAdditionalByIdAsyncAction,
	resetAction,
} from "./pointsActions";

const defaultAjaxState = {
	response: null,
	error: null,
	loading: false,
};

const initialState = {
	additional_list: defaultAjaxState,
	post_points_additional: defaultAjaxState,
	update_points_additional: defaultAjaxState,
	delete_points_additional_by_id: defaultAjaxState,
	points_additional_detail: defaultAjaxState,
};

export const pointsReducer = handleActions(
	new Map([
		// get points additional list
		[
			getPointsAdditionalListAsyncAction.request,
			(state, { payload }) => ({
				...state,
				additional_list: {
					...initialState.additional_list,
					loading: true,
				},
			}),
		],
		[
			getPointsAdditionalListAsyncAction.success,
			(state, { payload }) => ({
				...state,
				additional_list: {
					...initialState.additional_list,
					response: payload,
				},
			}),
		],
		[
			getPointsAdditionalListAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				additional_list: {
					...initialState.additional_list,
					error: payload,
				},
			}),
		],

		// post points additional create
		[
			postPointsAdditionalAsyncAction.request,
			(state, { payload }) => ({
				...state,
				post_points_additional: {
					...initialState.post_points_additional,
					loading: true,
				},
			}),
		],
		[
			postPointsAdditionalAsyncAction.success,
			(state, { payload }) => ({
				...state,
				post_points_additional: {
					...initialState.post_points_additional,
					response: payload,
				},
			}),
		],
		[
			postPointsAdditionalAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				post_points_additional: {
					...initialState.post_points_additional,
					error: payload,
				},
			}),
		],

		// delete points additional
		[
			deletePointsAdditionalByIdAsyncAction.request,
			(state, { payload }) => ({
				...state,
				delete_points_additional_by_id: {
					...initialState.delete_points_additional_by_id,
					loading: true,
				},
			}),
		],
		[
			deletePointsAdditionalByIdAsyncAction.success,
			(state, { payload }) => ({
				...state,
				delete_points_additional_by_id: {
					...initialState.delete_points_additional_by_id,
					response: payload,
				},
			}),
		],
		[
			deletePointsAdditionalByIdAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				delete_points_additional_by_id: {
					...initialState.delete_points_additional_by_id,
					error: payload,
				},
			}),
		],

		// put points additional update
		[
			updatePointsAdditionalAsyncAction.request,
			(state, { payload }) => ({
				...state,
				update_points_additional: {
					...initialState.update_points_additional,
					loading: true,
				},
			}),
		],
		[
			updatePointsAdditionalAsyncAction.success,
			(state, { payload }) => ({
				...state,
				update_points_additional: {
					...initialState.update_points_additional,
					response: payload,
				},
			}),
		],
		[
			updatePointsAdditionalAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				update_points_additional: {
					...initialState.update_points_additional,
					error: payload,
				},
			}),
		],

		// get points additional
		[
			getPointsAdditionalAsyncAction.request,
			(state, { payload }) => ({
				...state,
				points_additional_detail: {
					...initialState.points_additional_detail,
					loading: true,
				},
			}),
		],
		[
			getPointsAdditionalAsyncAction.success,
			(state, { payload }) => ({
				...state,
				points_additional_detail: {
					...initialState.points_additional_detail,
					response: payload,
				},
			}),
		],
		[
			getPointsAdditionalAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				points_additional_detail: {
					...initialState.points_additional_detail,
					error: payload,
				},
			}),
		],

		// reset
		[
			resetAction,
			(state, { payload }) => ({
				...state,
				[payload]: initialState[payload],
			}),
		],
	]),
	initialState
);
